import styled from '@emotion/styled';

import { colors } from '../../styles/colors';
import { ZeeFont, ZeeFontBold, ZeeFontMedium } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const Container = styled.div`
  background-color: ${colors.AppBgColor};
  color: ${colors.PrimaryWhiteColorAlpha80};

  .weight-bold {
    ${ZeeFontBold(14, 18)};
  }

  .title-tnc {
    ${ZeeFont(14, 18)};
  }

  ${ZeeFont(12, 18)};
  padding: 0px 16px 0px 16px;
  ul {
    list-style-type: none;
    padding: 0px;
  }

  table {
    border-space: 2px;
  }

  title {
    display: none;
  }

  h1 {
    margin: 22px 0;
    ${ZeeFontBold(16, 20)};
  }
  p {
    margin: 0 0 16px;
  }
  a {
    color: ${colors.PurpleLight};
    text-decoration: none;
  }
  h2 {
    ${ZeeFontBold(14, 20)};
    margin-bottom: 5px;
  }
  .bold_text {
    ${ZeeFontMedium(12, 18)};
  }
  /* Min width 900 - Max width 1199 */
  ${MQ.MediaMd} {
    ${ZeeFont(14, 20)};
    p {
      margin: 0 0 22px;
    }
    h2 {
      ${ZeeFont(16, 22)}
    }
  }

  /* Min width 1200 - Max width 1799 */
  ${MQ.MediaLg} {
    padding: 0 128px 10px;
    /* ${ZeeFont(18, 22)}; */
    p {
      margin: 0 0 24px;
    }
    h1 {
      ${ZeeFontBold(30, 42)};
      margin: 18px 0 14px;
      text-align: center;
    }
    h2 {
      ${ZeeFont(18, 24)};
    }
  }

  ${MQ.LgDesktop} {
    padding: 0 128px 10px;
    ${ZeeFont(18, 24)};
    p {
      margin: 0 0 30px;
    }
    h1 {
      ${ZeeFontBold(38, 52)};
    }
    h2 {
      ${ZeeFont(24, 26)};
    }
  }
  ${MQ.MediaSm} {
    /* margin-top: 49px; */
  }
  ${MQ.MediaLg} {
    /* margin-top: 63px; */
  }
  /* margin-top: 38px; */
`;
